import isEmpty from 'lodash.isempty'

import { getOrderlines } from '@http/endpoints'

import { formatOrderlinesFromOrders } from '../helpers'

import info from './modules/info'
import loading from './modules/loading'
import page from './modules/page'

export default {
  namespaced: true,
  modules: {
    info,
    loading,
    page,
  },
  state() {
    return {
      orders: undefined,
      maxOrderReached: false,
    }
  },
  getters: {
    get: (state) => state.orders,
    isMaxOrderReached: (state) => state.maxOrderReached,
    hasOrder: (state) => !isEmpty(state.orders),
  },
  mutations: {
    set: (state, orders) => {
      state.orders = orders
    },
    setMore: (state, orders) => {
      state.orders = (state.orders || []).concat(orders)
    },
    maxOrderReached: (state, value) => {
      state.maxOrderReached = value
    },
  },
  actions: {
    fetch: async ({ dispatch, rootGetters, commit }) => {
      const config = {
        request: getOrderlines,
        pathParams: { id: rootGetters['user/clientId'] },
      }

      const { payload } = await dispatch('http/request', config, { root: true })

      commit('set', formatOrderlinesFromOrders(payload))
      commit('maxOrderReached', !payload.next)
    },
    fetchMore: async ({ dispatch, rootGetters, getters, commit }) => {
      if (getters.isMaxOrderReached) {
        return
      }

      const config = {
        request: getOrderlines,
        pathParams: { id: rootGetters['user/clientId'] },
        queryParams: { page: getters['page/get'] },
      }

      const { payload } = await dispatch('http/request', config, { root: true })

      commit('setMore', formatOrderlinesFromOrders(payload))
      commit('maxOrderReached', !payload.next)
    },
  },
}
